<template>
  <motlet :options="motletOptions">
    <template #content>
      <!-- eslint-disable-next-line prettier/prettier -->
      <chart-equalizer
        v-if="showChart"
        :system="system"
        :items="instances"
        :values="values"
        :y-axis-max="yAxisMax"
        :levels="levels"
        :contextmenu="contextmenuChart"
      />
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import { isEmpty } from 'lodash';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import ChartEqualizer from '../chart/BarEqualizer.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    ChartEqualizer,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/abap/ThroughputEqualizer',
        title: 'Throughput',
      },
      messageNames: ['rawWorkload.3sec', 'rawWorkloadOwl.3sec', 'rawWorkloadSys.3sec'],
      messageFields: ['stime', 'endtimestamp', 'owlviewData'],
      messageSequence: 0,
      showChart: false,
      yAxisMax: 60,
      chartItems: [],
      value: {},
      values: [],
      contextmenuUrl: '',
    };
  },
  computed: {
    levels() {
      return [
        {
          name: '<= 100 ms',
          border: 1,
          color: '#87CC66',
        },
        {
          name: '<= 1 s',
          border: 10,
          color: '#7BBAE7',
        },
        {
          name: '<= 5 s',
          border: 50,
          color: '#FFDD00',
        },
        {
          name: '<= 10 s',
          border: 100,
          color: '#FF7800',
        },
        {
          name: '> 10 s',
          border: 101,
          color: '#FF0000',
        },
      ];
    },
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  methods: {
    contextmenuChart(event, selectedInstance) {
      event.preventDefault();
      const instance = isEmpty(selectedInstance) ? this.instances.find(i => i.active) : selectedInstance;
      const query = {
        dt: new Date().getTime(),
        sid: instance.systemId,
        iid: instance.id,
      };
      this.contextmenuParam = {
        show: true,
        x: event.clientX,
        y: event.clientY,
        items: [
          {
            icon: 'mdi-layers-search',
            text: 'Context Analysis',
            handler: () => window.open(`/views/analysis/context?${new URLSearchParams(query).toString()}`, '_blank'),
          },
        ],
      };
    },
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => {
        const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
        every(key, last.data, last.ctime, last.empty);
      });
    },
    wsDataHandler(key, response, ctime, empty) {
      // 그룹 별 첫번째 message 수신의 경우 값 초기화
      if (key.name == this.messageNames[0]) {
        ++this.messageSequence;
        this.value[key.instId] = { ms001: 0, ms010: 0, ms050: 0, ms100: 0, ms101: 0 };
      }

      // 2. 그룹별 데이터 누적처리
      // if (!empty) this.dataHandler(key, response, empty);
      this.dataHandler(key, response, ctime, empty);

      // 3. 그룹 별 마지막 message 수신의 경우 처리
      if (key.name == this.messageNames[this.messageNames.length - 1]) {
        // 시스템에 속한 인스턴스들의 값이 모두 취합 된 후
        if (this.messageSequence >= this.instances.length) {
          this.messageSequence = 0;
          this.values = this.instances.map(instance => this.getTypeData(instance.id));
        }
      }
    },
    dataHandler(key, response) {
      const mscounts = res => (res.owlviewData || '').split(';').filter(data => data != '');
      response.forEach(res => {
        mscounts(res).forEach(mscount => {
          if (mscount) {
            const counts = mscount.split('=');
            if (counts.length >= 2) {
              const ms = parseInt(counts[0]);
              const count = parseInt(counts[1]);
              if (ms <= 100) this.value[key.instId].ms001 += count;
              else if (ms <= 1000) this.value[key.instId].ms010 += count;
              else if (ms <= 5000) this.value[key.instId].ms050 += count;
              else if (ms <= 10000) this.value[key.instId].ms100 += count;
              else this.value[key.instId].ms101 += count;
            }
          }
        });
      });
    },
    // gauge data
    getTypeData(id) {
      const data = Object.keys(this.value[id] || {}).reduce((acc, msType) => {
        acc.push(this.value[id][msType]);
        return acc;
      }, []);
      return data.length ? data : Array(this.levels.length).fill(0);
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.instances.reduce(
          (acc, instance) =>
            acc.concat(
              this.messageNames.map(name => ({
                key: { name: name, sstmId: instance.systemId, instId: instance.id },
                fields: this.messageFields,
                handler: {
                  buffer: this.wsBufferedDataHandler,
                  every: this.wsDataHandler,
                },
              })),
            ),
          [],
        ),
      });
    },
    initialize() {
      this.showChart = false; // chart 관련 준비 값이 준비 된 후 chart 구동을 위한 값
      this.messageSequence = 0; // 시스템 단위 인스턴스 갯수 만큼 취합하기 위한 처리 증가 값
      // websoket message init
      this.wsRequestMessages = {};
    },
    changeInstancesHandler() {
      this.initialize();
      this.sendMessage();
      this.showChart = true;
    },
  },
};
</script>
